export const roUrlTest = "http://175.27.222.129/ro/PC/#/centerHtml";
export const roUrlFormal = "https://iot.mr-future.com/ro/PC/#/centerHtml";

export const lyjUrlTest = "http://175.27.222.129/lyj/PC/#/centerHtml";
// export const lyjUrlTest = "http://localhost:8082/lyj/PC/#/centerHtml";
export const lyjUrlFormal = "https://iot.mr-future.com/lyj/PC/#/centerHtml";
// export const lyjUrlFormal = "http://localhost:8082/lyj/PC/#/centerHtml";

export const lrwUrlTest = "http://175.27.222.129/brw/PC/#/centerHtml";
// export const lrwUrlTest = "http://localhost:8081/brw/PC/#/centerHtml";
export const lrwUrlFormal = "https://iot.mr-future.com/brw/PC/#/centerHtml";
// export const lrwUrlFormal = "http://localhost:8081/brw/PC/#/centerHtml";

export const zysUrlTest = "http://175.27.222.129/zys/PC/#/centerHtml";
export const zysUrlFormal = "https://iot.mr-future.com/zys/PC/#/centerHtml";
